import { render } from "./Exchange_Rates.vue?vue&type=template&id=a92c3dde"
import script from "./Exchange_Rates.vue?vue&type=script&lang=js"
export * from "./Exchange_Rates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__